module.exports = __webpack_public_path__ + "img/stock7.3f98e81f.png";